import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../redux/actions';
import KuposHelmet from '../../../common/KuposHelmet';
import HeroSection from '../../common/HeroSection/HeroSection';
import getIcons from '../../functions/getIcons/getIcons';
import ThemeElevenTitle from '../components/ThemeElevenTitle';
import { useTranslation } from 'react-i18next';

const ThemeElevenMaipu = props => {
  const {t} = useTranslation('common');
  return (
    <div className="themes-theme-eleven-maipu">
      <KuposHelmet />
      <div style={{ position: 'relative', marginTop: '-41px' }}>
        <HeroSection
          // height={'30vh'}
          height={'40vh'}
          heroImage={getIcons('airportbanner')}
        />
        <ThemeElevenTitle smallHeading={t("RUTA_MAIPU.RUTA_MAIPU_SMALL_HEADING")} boldHeading={t("RUTA_MAIPU.RUTA_MAIPU_BOLD_HEADING")} />

        <div className="new-container">
          <div className="route-img">
            <img src={t("RUTA_MAIPU.RUTAMAIPUIMG1")} alt="" className="" />
          </div>

          <div className="list-item">
            <div className="bullet" style={{ marginBottom: '11px' }}></div>
            <div className="descrip font10">
              {' '}
              {t("RUTA_MAIPU.MAIPULINE1")}
            </div>
          </div>

          <div className="list-item">
            <div className="bullet" style={{ marginBottom: '10px' }}></div>
            <div className="descrip font10">
            {t("RUTA_MAIPU.MAIPULINE2")}
            </div>
          </div>

          <div className="list-item">
            <div className="bullet" style={{ marginBottom: '29px' }}></div>
            <div className="descrip font10">
            {t("RUTA_MAIPU.MAIPULINE3")}
            {' '}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    themes: state.themes,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ThemeElevenMaipu);



// WEBPACK FOOTER //
// ./src/features/themes/ThemeEleven/pages/ThemeElevenMaipu.js